import { configureStore } from '@reduxjs/toolkit';
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import context from '@alltrails/context/slices/contextSlice';
import algoliaConfigs from '@alltrails/search/slices/algoliaConfigs';
import type { AlgoliaConfigs } from '@alltrails/types/algoliaConfigs';
import type Context from '@alltrails/types/Context';
import facebook, { type FacebookState } from '../slices/facebook';
import userConnectionLists, { type UserConnectionListsState } from '../slices/userConnectionLists';
import userConnections from '../slices/userConnections';

type State = {
  facebook: FacebookState;
  context: Context;
  userConnectionLists: UserConnectionListsState;
  algoliaConfigs: AlgoliaConfigs;
};

export const reducer = {
  facebook,
  context,
  userConnections,
  userConnectionLists,
  algoliaConfigs
};

export const buildStore = (preloadedState?: State) => configureStore({ reducer, preloadedState });

export type AppStore = ReturnType<typeof buildStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']>;

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = (selector: (state: RootState) => any) =>
  useSelector<RootState, any>(selector, shallowEqual);
